module.exports = __webpack_public_path__ + "static/media/no-image.440b9b23.jpg";